'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _lib = require('helpers/lib');

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectionCard = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(CollectionCard, _Component);

  function CollectionCard() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CollectionCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CollectionCard.__proto__ || (0, _getPrototypeOf2.default)(CollectionCard)).call.apply(_ref, [this].concat(args))), _this), _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = '/error-img.svg';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CollectionCard, [{
    key: 'render',
    value: function render() {
      var styles = require('./CollectionCard.scss');
      var item = this.props.item;

      var avt = '/beauty-thumb-1.png';
      avt = item && item.image ? item.image : avt;
      var thumbnailStyle = {
        backgroundImage: 'url(\'' + avt + '\')',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      };
      return !(0, _lodash.isEmpty)(item) ? _react2.default.createElement(
        'div',
        { className: styles.collectionCard },
        _react2.default.createElement(
          'div',
          { className: styles.card },
          item.image && _react2.default.createElement(
            _reactRouter.Link,
            { className: styles.cardImg, to: 'bo-suu-tap/' + item.handle },
            _react2.default.createElement('img', {
              src: (0, _lib.getUrlImage)(item.image),
              alt: item.name,
              onError: this.onErrorImage
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.totalItem },
            _react2.default.createElement(
              'div',
              { className: styles.quantity },
              item.shops.length
            ),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              '\u0111\u1ECBa \u0111i\u1EC3m'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: 'bo-suu-tap/' + item.handle, className: styles.name },
              item.name
            ),
            _react2.default.createElement(
              'div',
              { className: styles.likesCmt },
              _react2.default.createElement(
                'div',
                { className: styles.left },
                _react2.default.createElement(
                  'span',
                  { className: styles.like },
                  _react2.default.createElement('i', { className: 'fa fa-heart-o' }),
                  ' ',
                  item.totalLike
                ),
                _react2.default.createElement('i', { className: 'fa fa-bookmark-o' }),
                ' ',
                item.totalBookmark
              ),
              _react2.default.createElement('div', { className: styles.right })
            )
          )
        ),
        _react2.default.createElement('div', { className: styles.cardStack1 }),
        _react2.default.createElement('div', { className: styles.cardStack2 })
      ) : _react2.default.createElement(
        'div',
        { className: styles.collectionCard },
        _react2.default.createElement(
          'div',
          { className: styles.card },
          _react2.default.createElement('div', { className: styles.thumbnail, style: thumbnailStyle }),
          _react2.default.createElement(
            'div',
            { className: styles.totalItem },
            _react2.default.createElement(
              'div',
              { className: styles.quantity },
              '8'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              '\u0111\u1ECBa \u0111i\u1EC3m'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement(
              'div',
              { className: styles.description },
              'C\xE1c ti\u1EC7m nail "ch\u1EA5t ng\u1EA5t" s\u1EBD gi\xFAp b\u1EA1n bi\u1EBFn ho\xE1 v\u1EDBi m\u1ECDi phong c\xE1ch'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.likesCmt },
              _react2.default.createElement(
                'div',
                { className: styles.left },
                _react2.default.createElement(
                  'span',
                  { className: styles.like },
                  _react2.default.createElement('i', { className: 'fa fa-heart-o' }),
                  ' 235'
                ),
                _react2.default.createElement('i', { className: 'fa fa-bookmark-o' }),
                ' 19'
              ),
              _react2.default.createElement('div', { className: styles.right })
            )
          )
        ),
        _react2.default.createElement('div', { className: styles.cardStack1 }),
        _react2.default.createElement('div', { className: styles.cardStack2 })
      );
    }
  }]);
  return CollectionCard;
}(_react.Component), _class.propTypes = {
  item: _react.PropTypes.object
}, _temp2);
exports.default = CollectionCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Box/CollectionCard.js
// module id = 708
// module chunks = 0